import React from 'react'
import { Box, Typography } from '@mui/material'

interface TransportMapTabProps {
  searchTerm: string
  customerFilter: string
  statusFilter: string
}

const TransportMapTab: React.FC<TransportMapTabProps> = ({
  searchTerm,
  customerFilter,
  statusFilter,
}) => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="body1" color="text.secondary">
        Map view (placeholder). Search: &quot;{searchTerm}&quot;, Customer: {customerFilter}, Status: {statusFilter}
      </Typography>
    </Box>
  )
}

export default TransportMapTab
